<template>
  <div>
    <Button @click="goBack" type="primary">返回</Button>
    <div class="tc mt-5 mb-5">
      <h3>自开彩开奖设定 - 操作纪录</h3>
    </div>
    <div class="tc">
      <span class="mr-1">站别类型</span>
      <Select v-model="nowSite" style="width: 110px">
        <Option v-for="item in siteAllList" :value="item.id" :key="item.id">{{
          item.value
        }}</Option>
      </Select>
      <span class="ml-4 mr-1">彩种系列</span>
      <Select v-model="nowSeries" style="width: 120px">
        <Option v-for="item in gameSeries" :value="item.id" :key="item.id">{{
          item.value
        }}</Option>
      </Select>
      <span class="ml-4 mr-1">彩种</span>
      <Select v-model="nowGame" style="width: 130px">
        <Option
          v-for="item in filterGame"
          :value="item.gameid"
          :key="item.gameid"
          >{{ item.gamename }}</Option
        >
      </Select>
      <span class="ml-4 mr-1">操作时间</span>
      <DatePicker
        type="daterange"
        placeholder="开始时间 - 结束时间"
        v-model="searchDate"
        :clearable="false"
        style="width: 200px"
      />
      <Button
        class="mx-1 dateBtn"
        v-for="it in dateBtns"
        :key="it.id"
        @click="setDate(it.id)"
        >{{ it.name }}</Button
      >
      <Button class="mx-1" type="primary" @click="search">
        <Icon type="ios-search" />查询
      </Button>
      <slot name="recordBtn"></slot>
    </div>
    <lidaTable
      :propscolumns="columns"
      :data="apiData"
      :propsPageSize="20"
      :isSearch="false"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import moment from "moment-timezone";
import numAndAct from '../mixins/numAndAct'
export default {
  name: 'ActionRecord',
  mixins: [numAndAct],
  data () {
    return {
      columns: {
        gameclass: {
          title: '彩种名称',
          key: 'gameclass',
          align: 'center',
          render: (h, params) => {
            let gamename = this.getAllGame.find(it => it.gameid == params.row.gameclass).gamename
            return h('span', gamename)
          },
        },
        chperiod: {
          title: '期数',
          key: 'chperiod',
          align: 'center'
        },
        chperioddate: {
          title: '赛事时间',
          key: 'chperioddate',
          align: 'center'
        },
        action: {
          title: '动作',
          key: 'action',
          align: 'center'
        },
        oldvalue: {
          title: '变动前值',
          key: 'oldvalue',
          align: 'center'
        },
        newvalue: {
          title: '变动后值',
          key: 'newvalue',
          align: 'center'
        },
        datetime: {
          title: '操作时间',
          key: 'datetime',
          align: 'center'
        },
        chname: {
          title: '操作员',
          key: 'chname',
          align: 'center'
        }
      }
    }
  },
  computed: {
    ...mapGetters(["getmember", "getAllGame"]),
    apiQuery () {
      let endate = moment(this.searchDate[1]).add(1, 'days').format('YYYY-MM-DD')
      let stdate = moment(this.searchDate[0]).format('YYYY-MM-DD')
      let queryData = {
        username: this.getmember.uname,
        stdate: stdate,
        endate: endate,
        gamelist: this.nowGame || String(this.filterGame.filter(it => it.gameid != 0).map(it => it.gameid))
      }
      return queryData
    }
  },
  created () {
    this.search()
  },
  methods: {
    goBack () {
      this.$emit('close-record')
    },
    async search () {
      try {
        let res = await this.$axios.gameLobby.GamePeriodMarklog(this.apiQuery)
        if ('status' in res && res.status === 0) return
        res.sort((a, b) => new Date(a.datetime) - new Date(b.datetime))
        this.apiData = res
      } catch (error) {
        console.log(error)
      }
    },
  }
}
</script>